<template>
    <div class="carousel">
        <el-button
            :disabled="disablePrevious"
            icon="el-icon-arrow-left"
            class="carousel__button previous"
            @click="previous()"
        ></el-button>
        <div
            ref="container"
            class="carousel__container"
        >
            <div
                ref="carousel"
                class="feed-container"
            >
                <feed-card
                    v-for="(feed, index) in feeds"
                    :key="index"
                    :feed="feed"
                    class="card"
                    :class="index === 0 ? 'first-card-border' : ''"
                >
                    {{feed.name}}
                </feed-card>
            </div>
        </div>
        <el-button
            :disabled="disableNext"
            icon="el-icon-arrow-right"
            class="carousel__button next"
            @click="next()"
        ></el-button>
    </div>
</template>

<script>
import FeedCard from './feed-card.vue';
export default {

    name: 'Carousel',

    components:{
        FeedCard
    },

    props:{
        feeds: {
            type: Array,
            required: true
        }
    },

    data () {
        return {
            feedCardWidth: 316, // === feed card width (300px) + margin (16p)
            windowWidth:0,

            // All positions are relative to container div's left side
            positionRightCarousel: 0,
            positionLeftCarousel: 0,
            containerRightPosition: 0,
        };
    },
    computed:{
        disablePrevious(){
            return this.positionLeftCarousel >= 0;
        },
        disableNext(){
            return this.positionRightCarousel <= this.containerRightPosition;
        }
    },
    mounted(){
        this.$nextTick(()=>{
            this.setData(true);
        });
        window.addEventListener('resize', this.onWindowResize);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onWindowResize);
    },
    methods:{
        onWindowResize(){
            this.setData();
        },
        setData(mounted=false){
            const carousel = this.$refs.carousel;
            const carouselContainer = this.$refs.container;

            this.$set(this, 'containerRightPosition', this.$refs.container.offsetWidth);

            const rectCarousel = carousel.getBoundingClientRect();
            const rectContainer = carouselContainer.getBoundingClientRect();

            const positionLeftCarousel = rectCarousel.left - rectContainer.left;
            this.$set(this, 'positionLeftCarousel', positionLeftCarousel);
            const positionRightCarousel = rectCarousel.right - rectContainer.left;
            this.$set(this, 'positionRightCarousel', positionRightCarousel);


            if(
                this.windowWidth <= window.innerWidth
                && this.disableNext
                && !this.disablePrevious
                && !mounted
            ){
                /*
                    When we are at the end of the feed list (disableNext), if the feed list is
                    larger than the container (!disablePrevious) and the list is already mounted,
                    we want to stay at the end of the feed list on window resize

                    We add new available space to the carousel.
                */
                let availableSpace = window.innerWidth - this.windowWidth;
                this.updateCarouselPosition(availableSpace, true);
            }
            // we set windowWidth with new value for next comparison
            this.$set(this, 'windowWidth', window.innerWidth);
        },
        next() {
            this.updateCarouselPosition(this.feedCardWidth);
            this.setData();
            if(this.disableNext){
                /*
                    if we are at the end of the list the last card may be cut by the overflow hidden
                    from the container.
                    We use positions to get offset (in px) + 16 (last card margin) and add it to the
                    carousel position to ensure the card is fully visible.
                */
                let offset = this.containerRightPosition - this.positionRightCarousel + 16;
                this.updateCarouselPosition(offset, true);
            }

        },
        previous() {
            this.updateCarouselPosition(this.feedCardWidth, true);
            this.setData();
            if(this.disablePrevious){
                /*
                    Same as in next() but in the case were the first card is not fully visible.
                */
                let offset = 0 - this.positionLeftCarousel;
                this.updateCarouselPosition(offset, true);
            }
        },
        updateCarouselPosition(offset, add=false){
            // We move carousel div to the right by adding px to its position
            if(add){
                this.$refs.carousel.style.left = parseInt(this.$refs.carousel.style.left || 0) + offset + 'px';
            }else{
                // We move carousel div to the left by removing px to its position
                this.$refs.carousel.style.left = parseInt(this.$refs.carousel.style.left || 0) - offset + 'px';
            }
        }
    }
};
</script>

<style lang="scss">
    .carousel{
        display: flex;
        &__container{
            flex-grow: 1;
            position: relative;
            overflow: hidden;
            height: 143px;
            .feed-container{
                position: absolute;
                height: 100%;
                display: flex;
                transition: all 0.3s ease;
                .card{
                    height: 141px;
                    width:300px;
                    margin-right: 16px;
                    color: black;
                }
                .first-card-border{
                   border-left: 1px solid transparent;
                }
            }
        }
        &__button{
            height: 140px;
            width: 20px;
            padding: 2px;
        }
        .previous{
            margin-right: 1rem;
        }
        .next{
            margin-left: 1rem;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/page/FeedResourcesOverview/carousel.vue